import { render, staticRenderFns } from "./PrintTechniqueImage.vue?vue&type=template&id=12e3f52e&scoped=true"
import script from "./PrintTechniqueImage.vue?vue&type=script&lang=ts"
export * from "./PrintTechniqueImage.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PrintTechniqueImage.vue?vue&type=style&index=0&id=12e3f52e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "12e3f52e",
  null
  ,true
)

export default component.exports